import { FC } from "react";
import { Box, Button, Container, Flex, Heading, Image } from "@chakra-ui/react";
import { DocumentsSection as DocumentsSectionType } from "../config/landing.config";
import { useNavigate } from "react-router-dom";
import { secondaryColor } from "../../../utils/colors";

interface DocumentsSectionProps {
  config: DocumentsSectionType;
}

export const DocumentsSection: FC<DocumentsSectionProps> = ({ config }) => {
  const navigate = useNavigate();

  return (
    <Box bg={secondaryColor}  m={{ base: 4, md: 24 }} color="white" borderRadius="16">
      <Container maxW="100%" p={{ base: 6, md: 20 }}>
        <Flex direction="row" alignItems="center">
          <Box flex="1">
            <Heading
              as="h2"
              fontSize={{ base: "3xl", lg: "4xl" }}
              mb={6}
              whiteSpace="pre-line"
            >
              {config.title}
            </Heading>
            <Button
              variant="primary"
              onClick={() => navigate(config.ctaButton.href)}
            >
              {config.ctaButton.text}
            </Button>
          </Box>
          <Box flex="1">
            <Image
              src={config.image.src}
              alt={config.image.alt}
              width="100%"
              height="auto"
              objectFit="cover"
              borderRadius="lg"
            />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};
